import { translate } from "./i18n/customI18nProvider";

//even if it is not used yet
export default {
    version: process.env.REACT_APP_VERSION,
    applicationName: 'JM Contactless',
    apiUrl: window.location.origin + "/api",
    baseUrl: '',
    baseColor: "#08607e",
    baseColorLight: "#fafafa",
    baseColorHover: "#064a62",
    baseColorDark: "#80C0FF",
    successColor: "green",
    successColorDark: "#80FF80",
    dangerColor: "#c00",
    dangerColorDark: "#FF8080",
    // backgroundColor: '#EAE9EF',
    backgroundColor: '#FAFAFA',
    permissions: {
        NONE: {
            value: 0,
            name: ""
        },
        ENTRANCE_CHECKER: {
            value: 5,
            name: translate('custom.entrance_checker')
        },
        ORDER_AND_PAY: {
            value: 7,
            name: translate('custom.order_and_pay')
        },
        SERVER: {
            value: 10,
            name: translate('custom.server')
        },
        CASHIER: {
            value: 20,
            name: translate('custom.cashier')
        },
        ADMIN: {
            value: 30,
            name: translate('custom.admin')
        },
        SUPERADMIN: {
            value: 50,
            name: translate('custom.superadmin')
        }
    },
    entrance_types: {
        ENTRANCE: {
            value: 'entrance',
            // name: "Entrée normale"
            name: translate('custom.normal_entrance')
        },
        UNPAID: {
            value: 'unpaid',
            name: translate('custom.entrance_with_non_refundable_amount')
        },
        CREDIT: {
            value: 'credit',
            name: translate('custom.recharge')
        },
        REPEAT: {
            value: 'repeat_operation',
            name: translate('custom.repeat_operation')
        },
        IS_BRACELET_USED: {
            value: 'is_bracelet_used',
            name: translate('custom.is_bracelet_used')
        },
        ADD_MONEY_NON_REFUNDABLE: {
            value: 'add_money_non_refundable',
            name: translate('custom.recharge_non_refundable')
        },
        DEFECT_WRISTBAND: {
            value: 'defect_wristband',
            name: translate('custom.defective_bracelet')
        },
        TRANSFER_WRISTBAND: {
            value: 'transfer_wristband',
            name: translate('custom.transfer_bracelet')
        },
        ADD_ENTRANCE: {
            value: 'add_entrance',
            name: translate('custom.add_entrance')
        },
        REFUND: {
            value: 'refund',
            name: translate('custom.refund')
        },
        FORCED_REFUND: {
            value: 'forced_refund',
            name: translate('custom.forced_refund')
        },
        REPAIR_LINK: {
            value: 'repair_link',
            name: translate('custom.repair_link')
        },
        CHANGE_AGE: {
            value: 'change_age',
            name: translate('custom.change_age')
        }
    },
    ages: {
        LESS_16: {
            value: 0,
            name: translate('custom.everyone')
        },
        LESS_18: {
            value: 16,
            name: translate('custom.age_reverse_map.LESS_18')
        },
        MORE_18: {
            value: 18,
            name: translate('custom.age_reverse_map.MORE_18')
        }
    },
    entrance_ages: {
        LESS_16: {
            value: 0,
            name: translate('custom.age_reverse_map.LESS_16')
        },
        LESS_18: {
            value: 16,
            name: translate('custom.age_reverse_map.LESS_18')
        },
        MORE_18: {
            value: 18,
            name: translate('custom.age_reverse_map.MORE_18')
        }
    },
    ages_reverse_map: {
        0: "age_reverse_map.LESS_16",
        16: "age_reverse_map.LESS_18",
        18: "age_reverse_map.MORE_18"
    },
    transaction_types: {
        DEBIT: 'debit',
        CREDIT: 'credit',
        ENTRANCE: 'entrance',
        ZONE: 'zone',
        CHECKOUT: 'checkout',
        UNPAID: 'unpaid',
        REPEAT: 'repeat_operation',
        ADD_MONEY_NON_REFUNDABLE: 'add_money_non_refundable',
        DEFECT_WRISTBAND: 'defect_wristband',
        TRANSFER_WRISTBAND: 'transfer_wristband',
        ADD_ENTRANCE: 'add_entrance',
        REFUND: 'refund',
        FORCED_REFUND: 'forced_refund',
        TWINT_REFUND: 'twint_refund',
        CARD_REFUND: 'card_refund',
        MYPOS_REFUND: 'mypos_refund',
        POS_PHONE_REFUND: 'pos_phone_refund',
        FORM_REFUND: 'form_refund',
        BALANCE_TRANSFER_FROM_WRISTBAND: 'balance_transfer_from_wristband',
    },
    payment_types: {
        CASH: {
            value: 'cash',
            name: 'Cash',
            description: translate('custom.payment_types_description.CASH')
        },
        TWINT: {
            value: 'twint',
            name: 'TWINT',
            description: translate('custom.payment_types_description.TWINT')
        },
        TWINT_DIRECT: {
            value: 'twint_direct',
            name: 'TWINT direct',
            description: translate('custom.payment_types_description.TWINT_DIRECT')
        },
        CARD: {
            value: 'card',
            name: 'Cartes débit/crédit',
            description: translate('custom.payment_types_description.CARD')
        },
        MYPOS: {
            value: 'mypos',
            name: 'Cartes débit/crédit',
            description: translate('custom.payment_types_description.MYPOS')
        },
        POS_PHONE: {
            value: 'pos_phone',
            name: 'Cartes débit/crédit',
            description: translate('custom.payment_types_description.POS_PHONE')
        }
    },
    checkout_methods: {
        TWINT: {
            value: 'twint_refund',
            name: translate('custom.checkout_methods.TWINT.name'),
            description: translate('custom.checkout_methods.TWINT.description')
        },
        MYPOS: {
            value: 'mypos_refund',
            name: translate('custom.checkout_methods.MYPOS.name'),
            description: translate('custom.checkout_methods.MYPOS.description')
        },
        CARD: {
            value: 'card_refund',
            name: translate('custom.checkout_methods.CARD.name'),
            description: translate('custom.checkout_methods.CARD.description')
        },
        CREDIT_CARD: {
            value: 'credit_card',
            name: translate('custom.checkout_methods.CREDIT_CARD.name'),
            description: translate('custom.checkout_methods.CREDIT_CARD.description')
        },
        CASH: {
            value: 'checkout',
            name: translate('custom.checkout_methods.CASH.name'),
            description: translate('custom.checkout_methods.CASH.description')
        }
    },
    languages: {
        EN: {
            value: 'en',
            name: 'English'
        },
        FR: {
            value: 'fr',
            name: 'Français'
        },
        DE: {
            value: 'de',
            name: 'Deutsch'
        },
    },
    round: {
        // "0.01" : {
        //     value: 0.01,
        //     name: "0.01"
        // },
        "0.05" : {
            value: 0.05,
            name: "0.05"
        },
        "0.10" : {
            value: 0.10,
            name: "0.10"
        },
        "0.5" : {
            value: 0.5,
            name: "0.5"
        },
        "1" : {
            value: 1,
            name: "1"
        }
    },
    channel_types: {
        WEB: {
            value: 'web',
            name: 'Web',
            short: 'W'
        },
        APP: {
            value: 'app',
            name: 'App',
            short: 'A'
        }
    },
    ticket_category_ids: {
        GENERAL_TICKET : {
            value: 1292105,
            name: "1292105"
        },
        TEST_TICKET : {
            value: 123456,
            name: "123456"
        }
    },
    consumption_colors: [
        {id: 'purple', name: translate('custom.colors.purple'), colorCode: '#c6a9f4'},
        {id: 'red', name: translate('custom.colors.red'), colorCode: '#ef6c54'},
        {id: 'orange', name: translate('custom.colors.orange'), colorCode: '#ffcd81'},
        {id: 'gray', name: translate('custom.colors.gray'), colorCode: '#a6a4a3'},
        {id: 'green', name: translate('custom.colors.green'), colorCode: '#6dc778'},
    ],
    consumption_types: {
        QUANTITY: 'quantity',
        INPUT: 'input'
    },
    amounts_to_display: ["10", "20", "30", "40", "50", "60", "70", "100"],
    maxLoadAmount: 1000,
    valid_characters_regex: /[^a-zA-Z0-9.,;:'+\-/()?\\[\]{}`´~!"#%&<>÷=@_$£àáâäçèéêëìíîïñòóôöùúûüýßÀÁÂÄÇÈÉÊËÌÍÎÏÒÓÔÖÙÚÛÜÑ\s\n\r]/g,
    TWINT_PAYMENTS_ORDER_STATUS: {
        IN_PROGRESS: 'IN_PROGRESS',
        SUCCESS: 'SUCCESS',
        FAILURE: 'FAILURE',
    },
    TWINT_PAYMENTS_ORDER_REASON: {
        ORDER_PENDING: 'ORDER_PENDING',
        ORDER_CONFIRMATION_PENDING: 'ORDER_CONFIRMATION_PENDING',
        ORDER_OK: 'ORDER_OK'
    },
    TWINT_PAYMENTS_PAIRING_STATUS: {
        NO_PAIRING: 'NO_PAIRING'
    },
    amounts_to_display_choices: [
        {id: "10", name: "10"},
        {id: "20", name: "20"},
        {id: "30", name: "30"},
        {id: "40", name: "40"},
        {id: "50", name: "50"},
        {id: "60", name: "60"},
        {id: "70", name: "70"},
        {id: "100", name: "100"}
    ],
    donation_amounts: [1, 2, 3],
    printer_types: [
        {id: "epson", name: "EPSON"},
        {id: "tanca", name: "TANCA"},
        {id: "star", name: "STAR"},
        {id: "daruma", name: "DARUMA"},
        {id: "brother", name: "BROTHER"}
    ],
    device_types: {
        SMARTPHONE: {
            key: 'smartphone',
            name: translate('custom.smartphone')
        },
        MODEM: {
            key: 'modem',
            name: translate('custom.modem')
        },
        MYPOS_TERMINAL: {
            key: 'mypos_terminal',
            name: translate('custom.mypos_terminal')
        }
    },
    refund_status: {
        ERROR: 'error',
        WARNING: 'warning',
        REFUNDING: 'refunding',
        SUCCESS: 'success',
        CANCELLED: 'cancelled'
    },
    refund_methods: {
        MYPOS: 'mypos',
        CARD: 'card',
        TWINT: 'twint',
    },
    token_permissions: [
        { id: 'deposit_return', name: translate('custom.deposit_return') }
    ],
    PWL_STATUS: {
        INITIATED: 'initiated',
        PENDING: 'pending',
        TEMP_FAILED: 'temp_failed',
        API_UNREACHABLE: 'api_unreachable',
        TIMEOUT: 'timeout',
        SUCCESS: 'success',
        CANCELLED: 'cancelled',
        FAILED: 'failed',
        API_ERROR: 'api_error'
    },
    print_modes: [
        {value: 'always', name: translate('custom.print_modes.always')},
        {value: 'never', name: translate('custom.print_modes.never')},
        {value: 'ask', name: translate('custom.print_modes.ask')}
    ]
};